import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../stempz-logo.svg';

const Privacy: React.FC = () => {
    return (
        <div className="min-h-screen bg-white">
            {/* Header */}
            <header className="bg-teal-600 text-white py-6">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                    <Link to="/" className="text-2xl font-bold hover:text-teal-100 transition-colors inline-flex items-center gap-2">
                        <img src={logo} alt="" className="h-8 w-8 brightness-0 invert" />
                        Stempz
                    </Link>
                </div>
            </header>

            {/* Content */}
            <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-4xl">
                <h1 className="text-4xl font-bold text-gray-900 mb-8">Personvernpolicy</h1>

                <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
                    <p className="text-sm text-gray-500">Sist oppdatert: 26. januar 2026</p>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Introduksjon</h2>
                        <p>
                            Stempz ("vi", "oss", "vår") respekterer ditt personvern og er forpliktet til å beskytte
                            dine personopplysninger. Denne personvernpolicyen forklarer hvordan vi samler inn,
                            bruker og beskytter informasjonen din når du bruker vår app og tjenester.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Informasjon vi samler inn</h2>
                        <p>Vi samler inn følgende typer informasjon:</p>
                        <ul className="list-disc pl-6 mt-2 space-y-2">
                            <li><strong>Kontoinformasjon:</strong> Telefonnummer for kontoopprettelse og innlogging.</li>
                            <li><strong>Lojalitetsdata:</strong> Informasjon om dine lojalitetskort og stempler hos våre partnere.</li>
                            <li><strong>Posisjonsdata:</strong> Kun når du aktivt bruker kartfunksjonen for å finne nærliggende steder.</li>
                            <li><strong>Enhetsdata:</strong> Grunnleggende teknisk informasjon for å sikre at appen fungerer korrekt.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Hvordan vi bruker informasjonen</h2>
                        <p>Vi bruker informasjonen din til å:</p>
                        <ul className="list-disc pl-6 mt-2 space-y-2">
                            <li>Administrere din konto og lojalitetskort</li>
                            <li>Registrere og spore stempler fra våre partnere</li>
                            <li>Vise deg nærliggende partnersteder (kun med ditt samtykke)</li>
                            <li>Forbedre og utvikle våre tjenester</li>
                            <li>Kommunisere med deg om viktige oppdateringer</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Deling av informasjon</h2>
                        <p>
                            Vi selger aldri dine personopplysninger. Vi deler kun informasjon med:
                        </p>
                        <ul className="list-disc pl-6 mt-2 space-y-2">
                            <li><strong>Partnerbedrifter:</strong> Begrenset informasjon for å registrere stempler.</li>
                            <li><strong>Tjenesteleverandører:</strong> Tekniske partnere som hjelper oss med å drifte tjenesten.</li>
                            <li><strong>Myndigheter:</strong> Kun når loven krever det.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Datasikkerhet</h2>
                        <p>
                            Vi bruker bransjestandard sikkerhetstiltak for å beskytte dine data, inkludert kryptering
                            og sikker lagring. Lojalitetskortene dine lagres også lokalt på enheten din for offline-bruk.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Dine rettigheter</h2>
                        <p>Du har rett til å:</p>
                        <ul className="list-disc pl-6 mt-2 space-y-2">
                            <li>Be om innsyn i dine personopplysninger</li>
                            <li>Korrigere unøyaktige opplysninger</li>
                            <li>Slette din konto og tilhørende data</li>
                            <li>Trekke tilbake samtykke til databehandling</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Kontakt oss</h2>
                        <p>
                            Har du spørsmål om personvern? Kontakt oss på{' '}
                            <a href="mailto:hello@stempz.no" className="text-teal-600 hover:underline">
                                hello@stempz.no
                            </a>
                        </p>
                    </section>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-gray-900 text-gray-400 py-8 mt-12">
                <div className="container mx-auto px-4 text-center">
                    <p>© {new Date().getFullYear()} Stempz. Alle rettigheter reservert.</p>
                </div>
            </footer>
        </div>
    );
};

export default Privacy;
